import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogActions,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    CircularProgress
} from "@mui/material";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { useTheme } from "@mui/material/styles";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { useSelector } from "react-redux";
import api from "../Utils/Api";
import { useNavigate } from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import { baseapi } from "../Environmentalurl";
import {
  entity_id, Platform,
} from "../Utils/Const";

const Neft = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const fileInputRef = useRef(null);

    const [transactionId, setTransactionId] = useState("");
    const [amount, setAmount] = useState("");
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState("");
    const [base64Image, setBase64Image] = useState("");
    const [open, setOpen] = useState(false);
    const [responseData, setResponseData] = useState({});
    const [loading, setLoading] = useState(false);

    // History table state
    const [history, setHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(7);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const userData = useSelector((state) => state.auth?.userData);

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (!["image/jpeg", "image/jpg"].includes(file.type)) {
            alert("Only JPG images are allowed");
            return;
        }

        setImage(file);

        const reader = new FileReader();

        reader.onloadend = () => {
            setBase64Image(reader.result);
            setPreview(reader.result);
        };

        reader.readAsDataURL(file);
    };

    const currentDate = new Date().toISOString().split("T")[0];

    // 🔧 Fetch NEFT transaction history
    const fetchHistory = async () => {
        try {
            setHistoryLoading(true);
            const token = localStorage.getItem("token");
            const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
            const Cardno = JSON.parse(sessionStorage.getItem("virtualAccountNo"));

            const payload = {
                ReqType: "TAOneApp_NEFTReqstatusByList",
                GeoLocation: "12.9162944,77.6107175",
                MachineID: "72fc21309348f502",
                EntityID: entity_id,
                Mobilenumber: Mobilenumber,
                Platform: Platform,
                Statement: "ListWalletNEFTRequest",
                AccountNumber: Cardno
            };

            const res = await api.post(
                // `http://localhost:8089/apiwallet/api/services/nefttransactionhistory`,
                `${baseapi}/nefttransactionhistory`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res?.data?.Response_Code === "1900") {
                setHistory(res.data?.Info?.Table || []);
            } else {
                setHistory([]);
            }
        } catch (err) {
            setHistory([]);
        } finally {
            setHistoryLoading(false);
        }
    };

    // Load history automatically when the page mounts
    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const submitRequest = async () => {
        if (!transactionId) {
            alert("Enter Transaction Id");
            return;
        }

        if (!amount) {
            alert("Enter Amount");
            return;
        }

        if (!base64Image) {
            alert("Upload JPG Image");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const name = JSON.parse(sessionStorage.getItem("firstname"));
            const Mobilenumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
            const Cardno = JSON.parse(sessionStorage.getItem("virtualAccountNo"));

            const payload = {
                ReqType: "TAOneApp_NEFTEntry",
                GeoLocation: "12.9162944,77.6107175",
                MachineID: "72fc21309348f502",
                Trans_RefNo: transactionId,
                TotalAmount: Number(amount),
                Date: currentDate,
                RequestBy: name,
                EntityID: entity_id,
                Statement: "WalletNEFTRequest",
                Mobilenumber: Mobilenumber,
                Platform: Platform,
                AccountNumber: Cardno,
                Attachment: base64Image
            };

            const res = await api.post(
                // `http://localhost:8089/apiwallet/api/services/neftrequest`,
                `${baseapi}/neftrequest`,
                 payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setResponseData(res.data);
            setOpen(true);

            // 🔧 Refresh history + reset form after a successful submission
            if (res?.data?.Response_Code === "1000") {
                setTransactionId("");
                setAmount("");
                setImage(null);
                setPreview("");
                setBase64Image("");
                fetchHistory();
            }

        } catch (err) {

            if (err.response) {
                setResponseData(err.response.data);
            } else {
                setResponseData({
                    Response_Code: "500",
                    Message: "Something went wrong"
                });
            }

            setOpen(true);

        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const formatDateTime = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return (
            d.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }) +
            ", " +
            d.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
            })
        );
    };

    const formatAmount = (amt) => {
        if (amt === undefined || amt === null) return "-";
        return Number(amt).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 2,
        });
    };

    const statusChip = (status) => {
        const s = (status || "").toLowerCase();

        let color = "default";
        if (s === "pending") color = "warning";
        else if (s === "approved" || s === "success") color = "success";
        else if (s === "rejected" || s === "failed") color = "error";

        return (
            <Chip
                label={status || "-"}
                size="small"
                color={color}
                sx={{ fontWeight: 600 }}
            />
        );
    };
    const navigate = useNavigate();
    const navigateback = () => navigate("/dashboard/loadmoney");

    return (
        <>
            <Box px={7} bgcolor={isDark ? "#081028" : ""}>
                <DashboardHeader />
            </Box>

            <Box
                sx={{
                    maxWidth: "80%",
                    mx: "auto",
                    mt: 4,
                    mb: 3,
                }}
            >
                <Card
                    sx={{
                        borderRadius: 3,
                        boxShadow: 3,
                    }}
                >
                    <CardContent>


                        <Box display={"flex"} justifyContent={"space-between"}>
                            <Typography
                                variant="h5"
                                fontWeight="bold"
                                color="#2E7D32"
                                mb={3}
                            >
                                NEFT Request
                            </Typography>
                            <Button size="small" onClick={navigateback}>
                                Back
                            </Button>
                        </Box>


                        <Box
                            display="grid"
                            gridTemplateColumns={{
                                xs: "1fr",
                                md: "2fr 1fr 2fr auto",
                            }}
                            gap={2}
                            alignItems="end"
                        >
                            {/* Transaction Id */}
                            <Box>
                                <Typography mb={0.5} fontWeight={600}>
                                    Transaction Id
                                </Typography>

                                <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Enter Transaction Id"
                                    value={transactionId}
                                    onChange={(e) => setTransactionId(e.target.value)}
                                />
                            </Box>

                            {/* Amount */}
                            <Box>
                                <Typography mb={0.5} fontWeight={600}>
                                    Amount
                                </Typography>

                                <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Enter Amount"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                            </Box>

                            {/* Upload */}
                            <Box>
                                <Typography mb={0.5} fontWeight={600}>
                                    Upload Passbook
                                </Typography>

                                <input
                                    hidden
                                    ref={fileInputRef}
                                    type="file"
                                    accept=".jpg,.jpeg"
                                    onChange={handleImageChange}
                                />

                                <Box
                                    onClick={() => fileInputRef.current.click()}
                                    sx={{
                                        border: "1px dashed #2E7D32",
                                        borderRadius: 2,
                                        height: 40,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        bgcolor: "#F8FFF8",
                                        "&:hover": {
                                            bgcolor: "#EEF9EE",
                                        },
                                    }}
                                >
                                    <ImageOutlinedIcon
                                        sx={{
                                            color: "#2E7D32",
                                            mr: 1,
                                        }}
                                    />

                                    <Typography
                                        variant="body2"
                                        noWrap
                                    >
                                        {image ? image.name : "Choose JPG"}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Submit */}
                            <Button
                                variant="contained"
                                onClick={submitRequest}
                                disabled={loading}
                                sx={{
                                    height: 40,
                                    px: 5,
                                    bgcolor: "#2E7D32",
                                    whiteSpace: "nowrap",
                                    "&:hover": {
                                        bgcolor: "#256428",
                                    },
                                }}
                            >
                                {loading ? "Submitting..." : "Submit"}
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            {/* 🔧 NEFT Transaction History Table */}
            <Box
                sx={{
                    maxWidth: "80%",
                    mx: "auto",
                    mb: 6,
                }}
            >
                <Card
                    sx={{
                        borderRadius: 3,
                        boxShadow: 3,
                    }}
                >
                    <CardContent sx={{ p: 3 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <HistoryRoundedIcon sx={{ color: "#2E7D32" }} />
                                <Typography variant="h6" fontWeight="bold" color="#2E7D32">
                                    NEFT Transaction History
                                </Typography>
                            </Box>

                            <Button
                                size="small"
                                onClick={fetchHistory}
                                disabled={historyLoading}
                                sx={{ textTransform: "none", color: "#2E7D32" }}
                            >
                                {historyLoading ? "Refreshing..." : "Refresh"}
                            </Button>
                        </Box>

                        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow sx={{ bgcolor: isDark ? "#0F1B3D" : "#F1F8E9" }}>
                                        <TableCell sx={{ fontWeight: 700 }}>Transaction Ref No</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }} align="right">Amount</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>Value Date</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>Requested On</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }} align="center">Status</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {historyLoading ? (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                                                <CircularProgress size={28} sx={{ color: "#2E7D32" }} />
                                            </TableCell>
                                        </TableRow>
                                    ) : history.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                                                <Typography color="text.secondary">
                                                    No transactions found
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        history
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => (
                                                <TableRow
                                                    key={row.ID}
                                                    hover
                                                    sx={{
                                                        "&:last-child td, &:last-child th": { border: 0 },
                                                    }}
                                                >
                                                    <TableCell sx={{ fontWeight: 500 }}>
                                                        {row.TransactionRefNo}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 600 }}>
                                                        {formatAmount(row.Amount)}
                                                    </TableCell>
                                                    <TableCell>{formatDate(row.ValueDate)}</TableCell>
                                                    <TableCell>{formatDateTime(row.RequestDateteime)}</TableCell>
                                                    <TableCell align="center">
                                                        {statusChip(row.AuthorizationStatus)}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={history.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[7]}
                            sx={{
                                "& .MuiTablePagination-toolbar": {
                                    px: 2,
                                },
                                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                                {
                                    fontWeight: 500,
                                },
                            }}
                        />
                    </CardContent>
                </Card>
            </Box>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 1,
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        py: 4,
                        textAlign: "center",
                    }}
                >
                    {responseData?.Response_Code === "1000" ? (
                        <CheckCircleRoundedIcon
                            sx={{
                                fontSize: 65,
                                color: "#2E7D32",
                                mb: 2,
                            }}
                        />
                    ) : (
                        <ErrorRoundedIcon
                            sx={{
                                fontSize: 65,
                                color: "#d32f2f",
                                mb: 2,
                            }}
                        />
                    )}

                    <Typography
                        variant="h6"
                        fontWeight={600}
                        sx={{
                            lineHeight: 1.6,
                        }}
                    >
                        {responseData?.Message}
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: "center",
                        pb: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() => setOpen(false)}
                        sx={{
                            bgcolor:
                                responseData?.Response_Code === "1900"
                                    ? "#2E7D32"
                                    : "#d32f2f",
                            px: 5,
                            borderRadius: 2,
                            textTransform: "none",
                            "&:hover": {
                                bgcolor:
                                    responseData?.Response_Code === "1900"
                                        ? "#256428"
                                        : "#b71c1c",
                            },
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Neft;